import React, { useState } from 'react';
import HoverImage from './HoverImage';
import ContactPanel from './Contact';

const images = require.context('../resources', false, /\.(jpg|jpeg|png)$/);

const imageMap = images.keys().reduce((acc, imagePath) => {
  const imageName = imagePath.replace('./', '').replace(/\.[^/.]+$/, ''); // Dosya ismini almak
  acc[imageName] = images(imagePath); // Resim ismi ile yolu eşleştir
  return acc;
}, {});

// Cart bileşeni
const Cart = () => {
  return (
    <div style={styles.pageContainer}>

      <div style={styles.cartContainer}>
        
             {/* Logo */}
        <div style={{...styles.logo, padding:'40px'}}> {/* Spread operator (...) kullanarak styles.logo nesnesinin tüm özelliklerini alıp üzerine yeni özellikleri ekliyoruz.*/}
          <img src={imageMap["hepkarliLogo"]} alt="Logo" style={styles.logoImage}  />
        </div>

        {/* Linkler */}
        <div style={styles.links}>
        {/*   
          <LinkWithLogo href="https://www.trendyol.com/magaza/hepkarli-m-1073650" text="Link Trendyol" logoSrc={imageMap["trendyol"]} />
          <LinkWithLogo href="https://www.n11.com/magaza/hepkarli" text="Link n11" logoSrc={imageMap["n11"]} />
          <LinkWithLogo href="https://www.hepsiburada.com/magaza/hepkarli" text="Link Hepsiburada" logoSrc={imageMap["hepsiburada"]} />
          <LinkWithLogo href="https://www.pazarama.com/magaza/hepkarli" text="Link Pazarama" logoSrc={imageMap["pazarama"]} />
          <LinkWithLogo href="" text="Link PttAVM" logoSrc={imageMap["pttavm"]} />
        */}
          <HoverImage href="https://www.trendyol.com/magaza/hepkarli-m-1073650" text="Link Trendyol" logoSrc={imageMap["trendyol"]} />
          <HoverImage href="https://www.n11.com/magaza/hepkarli" text="Link n11" logoSrc={imageMap["n11"]} />
          <HoverImage href="https://www.hepsiburada.com/magaza/hepkarli" text="Link Hepsiburada" logoSrc={imageMap["hepsiburada"]} />
          <HoverImage href="https://www.pazarama.com/magaza/hepkarli" text="Link Pazarama" logoSrc={imageMap["pazarama"]} />
          <HoverImage href="https://www.pttavm.com/magaza/hepkarliavm" text="Link PttAVM" logoSrc={imageMap["pttavm"]} />
        </div>

        <ContactPanel/>
      </div>


    </div>
  );
}

// Her link için logo ve metin içeren bileşen
const LinkWithLogo = ({ href, text, logoSrc }) => {
  return (
    <div style={styles.linkWithLogo}>
      <a  href={href} >
        <img src={logoSrc} style={styles.linkLogo} />
      </a>
     {/*  <a href={href} style={styles.link}>{text}</a> */}
    </div>
  );
}

// Stil ayarları
const styles = {
  // Sayfa ortalamayı sağlayan container
  pageContainer: {
    display: 'flex',
    justifyContent: 'center', // Yatayda ortala
    alignItems: 'center', // Dikeyde ortala
    height: '100vh', // Sayfa yüksekliğini %100 yap
    backgroundImage: `url(${imageMap["back"]})`, // Sayfa arka plan rengi
  },
  cartContainer: {
    border: '1px solid #ccc',
    padding: '20px',
    width: '300px',
    textAlign: 'center',
    borderRadius: '18px',
    backgroundColor: '#fff'
  },
  logo: {
    marginBottom: '20px',
    position: 'relative'
  },
  logoImage: {
    width: '180px',
    height: 'auto',
    'border-radius': '42%',
    position: 'absolute',
    top: '-100px',         /* Kareyi üstten kesmek için daireyi yukarıya kaydırıyoruz */
/*     left: '50%',    */       /* Dairenin ortalanması için sol konumu %50 */
    transform: 'translateX(-50%)'
  },
  links: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '25px',
  },
  linkWithLogo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  linkLogo: {
    width: '100px',
    height: 'auto'
  },
  link: {
    textDecoration: 'none',
    color: '#007bff',
    fontSize: '16px',
    fontWeight: 'bold',
  }
};

export default Cart;